import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export type I18N = typeof i18n;
export type TranslationLocale = 'es-CO' | 'es-ES' | 'en' | 'pt';

export type CreateI18N = {
  locale: TranslationLocale;
  data: Record<string, string>;
};

let IS_INIT = false;

export const createI18n = (options: CreateI18N) => {
  if (!options) return;
  if (IS_INIT) return i18n;

  const { locale, data } = options;

  i18n.use(initReactI18next).init({
    resources: {
      [locale]: {
        translation: data,
      },
    },
    lng: locale,
    fallbackLng: locale,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

  IS_INIT = true;

  return i18n;
};
